import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '@app/shared';
import { LinqFormsModule } from '@app/shared/forms/forms.module';
import { VoidPaymentsService } from './void-payments/services/void-payments.service';
import { VoidPaymentsComponent } from './void-payments/void-payments.component';

@NgModule({
	providers: [VoidPaymentsService],
	imports: [CommonModule, SharedModule, LinqFormsModule, VoidPaymentsComponent],
	exports: [VoidPaymentsComponent],
})
export class CashManagmentSchoolAccountingSharedModule {}
